export {default as CandidateEditProfile} from './CandidateEditProfile.connect';
